import React, { useState } from 'react';
import Button from '../buttons/button';

const Projects = ({ image, alt, nom_real, description, link }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    // Appliquer l'effet uniquement sur les petits écrans
    if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
      setIsFlipped(prev => !prev);
    }
  };

  return (
    <div className="real">
      <div 
        className={`cardReal ${isFlipped ? 'flipped' : ''}`} 
        onClick={handleCardClick}
      >
        <div className="flip">
          <div className="front">
            <img className="image" src={image} alt={alt} loading="lazy"/>
            <h2 className='title'>{nom_real}</h2>
          </div>

          <div className="back">
            <div className='description'>{description}</div>
            <Button text="Voir la réalisation" link={link} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
